// extracted by mini-css-extract-plugin
module.exports = {"authModeSwitch":"auth-mode-switch_authModeSwitch__UEbrv"};